import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import './Swiper.css';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import HeroSection from './HeroSection';
import HeroSection2 from './HeroSection2';
import HeroSection3 from './HeroSection3';

const SwiperHero = () => {
  return (
    <>
      <Swiper
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper"
      >
        <SwiperSlide>
          <HeroSection />
        </SwiperSlide>
        <SwiperSlide>
          <HeroSection2 />
        </SwiperSlide>
        <SwiperSlide>
          <HeroSection3 />
        </SwiperSlide>
      </Swiper>
    </>)
}

export default SwiperHero